const RELOAD_FLAG_KEY = 'nolan-stale-chunk-reload-at'
const RELOAD_COOLDOWN_MS = 5 * 60 * 1000

const STALE_CHUNK_PATTERNS = [
  /ChunkLoadError/i,
  /Loading chunk [\w-]+ failed/i,
  /Loading CSS chunk [\w-]+ failed/i,
  /importScripts.*\.chunk\.js.*failed to load/i
]
const CHUNK_FILE = /\.chunk\.(js|css)/
const HTML_FOR_SCRIPT = "Unexpected token '<'"

const matchesStaleChunk = message => STALE_CHUNK_PATTERNS.some(pattern => pattern.test(message))

const getEventMessages = event => {
  const messages = []
  if (event?.message) messages.push(event.message)
  const values = event?.exception?.values || []
  values.forEach(value => {
    messages.push(`${value.type || ''}: ${value.value || ''}`)
  })
  return messages
}

const eventReferencesChunkFile = event => {
  const values = event?.exception?.values || []
  return values.some(value =>
    (value.stacktrace?.frames || []).some(frame =>
      CHUNK_FILE.test(frame.filename || frame.abs_path || '')
    )
  )
}

// True when the error is caused by the browser requesting a code-split
// chunk that no longer exists on the host — i.e. a tab from a previous
// deployment. These are not code bugs; the recovery is a fresh page load.
export const isStaleChunkEvent = event => {
  const messages = getEventMessages(event)
  if (messages.some(matchesStaleChunk)) return true
  // Stale chunk requests can also surface as the host serving index.html
  // (starting with '<') in place of a missing .chunk.js file.
  return messages.some(message => message.includes(HTML_FOR_SCRIPT)) &&
    eventReferencesChunkFile(event)
}

// The same test for the Error an ErrorBoundary catches; its stack stands in for Sentry's frames.
export const isStaleChunkError = error => {
  if (!error) return false
  const message = `${error.name || ''}: ${error.message || ''}`
  return matchesStaleChunk(message) || (message.includes(HTML_FOR_SCRIPT) && CHUNK_FILE.test(error.stack || ''))
}

// Force a one-shot reload (rate-limited) so the user picks up the new
// build instead of staying stuck on dead chunk references. True when it reloads.
export const recoverFromStaleChunk = () => {
  try {
    const lastReloadAt = Number(window.sessionStorage.getItem(RELOAD_FLAG_KEY) || 0)
    if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) return false
    window.sessionStorage.setItem(RELOAD_FLAG_KEY, String(Date.now()))
    window.location.reload()
    return true
  } catch (_) {
    // sessionStorage unavailable (e.g. some private modes) — do nothing
    // rather than risk a reload loop.
    return false
  }
}
